import { BOOKING_NATURE_VALUE_PRO } from "@cloudspire/legacy-resources/src/constants/booking";

/**
 * Retourne vrai si la nature de la réservation est pour les professionnels.
 */
export default function bookingIsNatureProfessional({ booking }) {
  return booking.nature === BOOKING_NATURE_VALUE_PRO;
}
